import { Client as CoreApiClient } from './CoreApi';
import { CartClient as DynamicwebApiClient, OrderlineClient} from './DynamicwebApi';
import axios, { AxiosInstance } from 'axios';

export default class ApiProvider {
    public static getApiClient(): CoreApiClient {
        return new CoreApiClient('', this.getAxios());
    }
    public static getDwApiClient(): DynamicwebApiClient {
        return new DynamicwebApiClient('', this.getAxios());
    }

    public static getDwApiOrderlineClient(): OrderlineClient {
        return new OrderlineClient('', this.getAxios());
    }

    private static getAxios(): AxiosInstance {
        const ax = axios.create();
        ax.interceptors.request.use(req => {
            req.url += req.url.indexOf('?') > -1
                ? '&'
                : '?';
            
            req.url += '_ts=' + Math.random();
            return req;
        })
        return ax;
    }
}